module.exports = __webpack_public_path__ + "img/Recurso 18@300x.bcdc41f6.webp";